import moment from 'moment';
import React, { memo, useState } from 'react';
import { Col, Row, Button, Modal } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { deleteRequest } from '../../../utils/axiosRequests';
import {
  deleteConfirmation,
  formatOldPrescriptionData,
  isExistAnyEyeGlass,
  isExistAnyHistory,
  isExistAnyInfertilityData,
  isExistAnyOnExamination,
  isExistAnyRehabData,
  leftOrRightItems,
  getDuration,
} from '../../../utils/helpers';
import TemplateModal from '../modals/templateModal';
import DynamicPrescriptionItemView from './views/dynamicPrescriptionItem';
import DiagnosisView from './diagnosisView';
import RxView from './rxView';
import AdviceView from './views/advice';
import ChiefComplainView from './views/chiefComplain';
import EyeGlassView from './views/eyeGlassView';
import FollowUpView from './views/followUp';
import HistoryView from './views/historyView';
import InfertilityView from './views/infertility';
import InvestigationView from './views/investigation';
import OnExaminationView from './views/onExamination';
import ReferredtoView from './views/referredto';
import RehabilitationView from './views/rehabilitationView';
import SpecialNoteView from './views/specialNoteView';
import TreatmentPlanView from './views/treatmentPlan';
import HeartRate from '../../../assets/icons/HeartRate.png';
import OxygenSaturation from '../../../assets/icons/OxygenSaturation.png';
import BodyTemparature from '../../../assets/icons/BodyTemparature.png';
import BloodPressure from '../../../assets/icons/BloodPresure.png';

const PatientHistoryRight = ({
  patientData,
  prescriptions,
  setPrescriptions,
  appointment,
  note,
}) => {
  //console.log(prescriptions, 'datadata1');
  const prescriptionItems = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.prescriptionItems,
  );
  const [isTemplateModal, setIsTemplateModal] = useState(false);
  const [prescriptionData, setPrescriptionData] = useState({});
  const [openAccordionItems, setOpenAccordionItems] = useState({});
  const [prescriptionModal, setPrescriptionModal] = useState(false);

  const navigate = useNavigate();
  const reversePrescriptions = [...prescriptions];
  const lastPrescription = reversePrescriptions?.length
    ? reversePrescriptions[0]
    : null;
  //console.log('lastPrescription: ', lastPrescription);

  const deletePrescription = (prescriptionId) => {
    deleteRequest(`prescriptions/${prescriptionId}`)
      .then((data) => {
        const result = prescriptions.filter(
          (prescription) => prescription.id !== prescriptionId,
        );
        setPrescriptions([...result]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const createTemplateModal = (prescription, e) => {
    setPrescriptionData({
      organizationId: prescription?.organizationId?.id,
      chiefComplains: prescription?.chiefComplains,
      onExaminations: prescription?.onExaminations,
      diagnoses: prescription?.diagnoses,
      histories: prescription?.histories,
      medicines: prescription?.medicines,
      advices: prescription?.advices,
      followUps: prescription?.followUps,
      referredto: prescription?.referredto,
      investigations: prescription?.investigations,
      eyeGlass: prescription?.eyeGlass,
      medicineIds: prescription?.medicineIds,
      medicineType: prescription?.medicineType,
    });
    setIsTemplateModal(true);
    e.stopPropagation();
  };

  const getFormattedAdvices = (advices) => {
    let formatedAdvices = [];
    let key = 'untitled';
    advices?.forEach((item) => {
      if (item?.title) {
        key = item?.title;
        formatedAdvices[key] = [item];
      } else {
        if (Array.isArray(formatedAdvices[key])) {
          formatedAdvices[key].push(item);
        } else {
          formatedAdvices[key] = [item];
        }
      }
    });
    return formatedAdvices;
  };

  const chiefComplainView = (element, selectedChiefComplains) => {
    if (selectedChiefComplains?.length === 0) return false;

    return (
      <ChiefComplainView
        element={element}
        key={'chiefComplain'}
        prescriptionItems={prescriptionItems}
        selectedChiefComplains={selectedChiefComplains}
        isHistoryPage={true}
      />
    );
  };

  const treatmentPlanView = (element, selectedTreatmentPlans) => {
    if (selectedTreatmentPlans?.length === 0) return false;

    return (
      <TreatmentPlanView
        element={element}
        key={'treatmentPlan'}
        prescriptionItems={prescriptionItems}
        selectedTreatmentPlans={selectedTreatmentPlans}
        isHistoryPage={true}
      />
    );
  };

  const historyView = (element, selectedHistories, isInRightSide) => {
    if (!isExistAnyHistory(selectedHistories)) return false;

    return (
      <HistoryView
        element={element}
        key={'history'}
        selectedHistories={selectedHistories}
        prescriptionItems={prescriptionItems}
        isHistoryPage={true}
        isInRightSide={true}
      />
    );
  };

  const viewDiagnosis = (element, selectedDiagnosis, selectedStage) => {
    if (selectedDiagnosis?.length === 0 && !selectedStage?.isShow) return false;

    return (
      <DiagnosisView
        element={element}
        key={'diagnosis'}
        selectedDiagnosis={selectedDiagnosis}
        prescriptionItems={prescriptionItems}
        selectedStage={selectedStage}
        isHistoryPage={true}
      />
    );
  };

  const referredToView = (element, selectedReferredto) => {
    if (selectedReferredto?.length === 0 && !selectedReferredto?.length) {
      return false;
    }

    return (
      <ReferredtoView
        element={element}
        key={'referredto'}
        prescriptionItems={prescriptionItems}
        selectedReferredto={selectedReferredto}
        isHistoryPage={true}
      />
    );
  };

  const followUpView = (element, selectedFollowUps) => {
    if (selectedFollowUps?.length === 0) return false;

    return (
      <FollowUpView
        element={element}
        key={'followup'}
        prescriptionItems={prescriptionItems}
        selectedFollowUps={selectedFollowUps}
        isHistoryPage={true}
      />
    );
  };

  const adviceView = (element, selectedAdvices) => {
    if (selectedAdvices?.length === 0) return false;

    return (
      <AdviceView
        element={element}
        key={'advice'}
        prescriptionItems={prescriptionItems}
        selectedAdvices={selectedAdvices}
        isHistoryPage={true}
      />
    );
  };

  const investigationView = (element, selectedInvestigations) => {
    if (selectedInvestigations?.length === 0) {
      return false;
    }
    return (
      <InvestigationView
        element={element}
        key={'investigation'}
        prescriptionItems={prescriptionItems}
        selectedInvestigations={selectedInvestigations}
        isHistoryPage={true}
      />
    );
  };

  const viewRx = (element, prescriptionData) => {
    if (prescriptionData?.medicines?.length === 0) {
      return false;
    }
    return (
      <RxView
        selectedMedicines={prescriptionData?.medicines}
        prescriptionItems={prescriptionItems}
        element={element}
        key={'rx'}
        isHistoryPage={true}
        medicineType={prescriptionData?.medicineType}
      />
    );
  };

  const onExaminationView = (element, selectedOnExamination) => {
    if (!isExistAnyOnExamination(selectedOnExamination)) {
      return false;
    }
    return (
      <OnExaminationView
        element={element}
        key={'onExamination'}
        selectedOnExamination={selectedOnExamination}
        prescriptionItems={prescriptionItems}
        isHistoryPage={true}
      />
    );
  };

  const specialNoteView = (element, specialNotes) => {
    if (specialNotes) {
      if (specialNotes?.length === 0) {
        return false;
      }
    } else {
      return false;
    }
    return (
      <SpecialNoteView
        selectedSpecialNotes={specialNotes}
        prescriptionItems={prescriptionItems}
        element={element}
        key={'specialNote'}
        isHistoryPage={true}
      />
    );
  };

  const viewRehabilitation = (element, selectedRehabilitation) => {
    if (!isExistAnyRehabData(selectedRehabilitation)) {
      return false;
    }
    return (
      <RehabilitationView
        selectedRehabilitation={selectedRehabilitation}
        element={element}
        key={'rehab'}
        prescriptionItems={prescriptionItems}
        isHistoryPage={true}
      />
    );
  };

  const eyeGlassView = (element, selectedEyeGlass) => {
    if (!isExistAnyEyeGlass(selectedEyeGlass)) {
      return false;
    }
    return (
      <EyeGlassView
        selectedEyeGlass={selectedEyeGlass}
        prescriptionItems={prescriptionItems}
        element={element}
        key={'eye-glass'}
        isHistoryPage={true}
      />
    );
  };

  const dynamicItemView = (element, dynamicItems) => {
    const itemName = element.name;
    const items = (dynamicItems || {})[itemName] || [];
    if (items.length === 0) return false;
    return (
      <DynamicPrescriptionItemView
        element={element}
        key={itemName}
        prescriptionItems={prescriptionItems}
        selectedItems={items}
        setSelectedItems={() => {}}
        deleteItem={() => {}}
        isHistoryPage={true}
      />
    );
  };

  const infertilityView = (element, selectedInfertilities) => {
    if (!isExistAnyInfertilityData(selectedInfertilities)) {
      return false;
    }
    return (
      <InfertilityView
        element={element}
        isHistoryPage={true}
        key={'infertility'}
        prescriptionItems={prescriptionItems}
        selectedInfertilities={selectedInfertilities}
      />
    );
  };

  const addNewRxButton = () => {
    return (
      <div className="add-new-rx mb-3">
        <span>
          <i className="fa fa-plus pr-2"></i>
          Add New Rx
        </span>
      </div>
    );
  };

  const toggleAccordionItem = (key) => {
    setOpenAccordionItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const followUpPrescription = () => {
    const data = prescriptions?.length > 0 ? prescriptions[0] : {};
    navigate('/prescription', {
      state: {
        prescription: data,
        dob: data?.patientId?.dob,
        note: note,
        history: 'editFromHistory',
        appointment:
          appointment && appointment?.status !== 'completed'
            ? appointment
            : null,
      },
    });
  };

  const handleShowPrescription = (e, prescription) => {
    console.log('show pres: ', prescription);
    setPrescriptionData(prescription);
    setPrescriptionModal(true);
  };

  const handleFollowUp = (prescription, e) => {
    console.log('follo: ', prescription);
    if (appointment && appointment?.status !== 'completed') {
    }
    navigate('/prescription', {
      state: {
        prescription: prescription,
        dob: prescription?.patientId?.dob,
        note: note,
        history: 'editFromHistory',
        appointment:
          appointment && appointment?.status !== 'completed'
            ? appointment
            : null,
      },
    });
  };

  const handleAddNewPrescription = (e) => {
    if (appointment && appointment?.status !== 'completed') {
      navigate('/prescription', {
        state: {
          appointment,
          dob: patientData?.dob,
          history: 'onlyAppointment',
        },
      });
    } else {
      navigate('/prescription', {
        state: {
          patientData: patientData,
          dob: patientData?.dob,
          history: 'new',
        },
      });
    }
  };

  const isAccordionOpen = (key) => !!openAccordionItems[key];

  return (
    // <div>
    //   {appointment && appointment?.status !== 'completed' ? (
    //     <Link
    //       to="/prescription"
    //       state={{
    //         appointment,
    //         dob: patientData?.dob,
    //         history: 'onlyAppointment',
    //       }}
    //     >
    //       {addNewRxButton()}
    //     </Link>
    //   ) : (
    //     <Link
    //       to={'/prescription'}
    //       state={{
    //         patientData: patientData,
    //         dob: patientData?.dob,
    //         history: 'new',
    //       }}
    //     >
    //       {addNewRxButton()}
    //     </Link>
    //   )}
    //   {prescriptions.length > 0 && (
    //     <Row className="mt-2 application-history dotted-border ml-0">
    //       <Col>
    //         <Accordion defaultActiveKey={null} alwaysOpen>
    //           {prescriptions?.map((data, index) => {
    //             console.log(data, 'datadata');
    //             if (data?.medicines?.length > 0) {
    //               data.medicines = formatOldPrescriptionData(data.medicines);
    //             }
    //             return (
    //               <Accordion.Item
    //                 eventKey={index}
    //                 key={index}
    //                 className="mb-3 prescription-history"
    //               >
    //                 <Accordion.Header
    //                   onClick={(e) => toggleAccordionItem(index)}
    //                 >
    //                   <div className="justify-content-space-between-wrap pt-2">
    //                     <div style={{ marginTop: '-4px' }}>
    //                       <div className="prescription-number-circle">
    //                         <div>{++index}</div>
    //                       </div>
    //                       <span className="accordion-title-text">
    //                         {data?.createdAt
    //                           ? moment(data?.createdAt).format('D MMMM, YYYY')
    //                           : ''}
    //                       </span>
    //                     </div>
    //                     <div className="right-edit-icon">
    //                       <span
    //                         className="create-template-btn"
    //                         style={{
    //                           display: 'inline-block',
    //                           color: '#00b38c',
    //                         }}
    //                       >
    //                         {isAccordionOpen(index) ? (
    //                           <i className="fa fa-eye-slash"></i>
    //                         ) : (
    //                           <i className="fa fa-eye"></i>
    //                         )}
    //                         {isAccordionOpen(index) ? ' Hide' : ' Show'}{' '}
    //                         Prescription
    //                       </span>
    //                       |
    //                       <span
    //                         className="create-template-btn"
    //                         onClick={(e) => createTemplateModal(data, e)}
    //                         style={{ width: '6.2rem', display: 'inline-block' }}
    //                       >
    //                         <i className="fa fa-file"></i> Templates
    //                       </span>
    //                       |
    //                       <Link
    //                         to={'/prescription'}
    //                         className="pres-edit"
    //                         style={{ width: '6.6rem', display: 'inline-block' }}
    //                         state={{
    //                           prescription: data,
    //                           dob: data?.patientId?.dob,
    //                           note: note,
    //                           history: 'editFromHistory',
    //                         }}
    //                       >
    //                         <i className="fa fa-edit"></i> Follow Up
    //                       </Link>
    //                       |
    //                       <span
    //                         className="pres-del"
    //                         style={{ width: '4.3rem', display: 'inline-block' }}
    //                         onClick={(e) => {
    //                           deleteConfirmation(deletePrescription, data.id);
    //                           e.stopPropagation();
    //                         }}
    //                       >
    //                         <i className="fa fa-trash-alt"></i> Delete
    //                       </span>
    //                     </div>
    //                   </div>
    //                   <div
    //                     className="justify-content-centered mr-1 mt-4 pt-3 pb-2"
    //                     style={{ borderTop: '1px solid #e9e9e9' }}
    //                   >
    //                     <span className="indivisual-prescription-stat">
    //                       Chief Complain:{' '}
    //                       {data.chiefComplains.length
    //                         ? data.chiefComplains.length
    //                         : 0}
    //                     </span>
    //                     <span className="indivisual-prescription-stat">
    //                       Diagnosis:{' '}
    //                       {data.diagnoses.length ? data.diagnoses.length : 0}
    //                     </span>
    //                     <span className="indivisual-prescription-stat">
    //                       Rx:{' '}
    //                       {data.medicines.length ? data.medicines.length : 0}
    //                     </span>
    //                     <span className="indivisual-prescription-stat">
    //                       Investigation:{' '}
    //                       {data.investigations.length
    //                         ? data.investigations.length
    //                         : 0}
    //                     </span>
    //                     <span className="indivisual-prescription-stat">
    //                       Advice:{' '}
    //                       {data.advices.length ? data.advices.length : 0}
    //                     </span>
    //                     <span className="indivisual-prescription-stat">
    //                       Follow up:{' '}
    //                       {data.followUps.length ? data.followUps.length : 0}
    //                     </span>
    //                   </div>
    //                 </Accordion.Header>
    //                 <Accordion.Body>
    //                   <div className="row prescription-body pt-2">
    //                     {leftOrRightItems(prescriptionItems, 'left').length >
    //                       0 && (
    //                       <div className="prescription-body-left">
    //                         {leftOrRightItems(prescriptionItems, 'left').map(
    //                           (element) => {
    //                             if (element.name === 'chief-complain') {
    //                               return chiefComplainView(
    //                                 element,
    //                                 data?.chiefComplains,
    //                               );
    //                             } else if (element.name === 'treatment-plan') {
    //                               return treatmentPlanView(
    //                                 element,
    //                                 data?.treatmentPlans,
    //                               );
    //                             } else if (element.name === 'referred-to') {
    //                               return referredToView(
    //                                 element,
    //                                 data?.referredto,
    //                               );
    //                             } else if (element.name === 'history') {
    //                               return historyView(element, data?.histories);
    //                             } else if (element.name === 'diagnosis') {
    //                               return viewDiagnosis(
    //                                 element,
    //                                 data?.diagnoses,
    //                                 data?.staging,
    //                               );
    //                             } else if (element.name === 'follow-up') {
    //                               return followUpView(element, data?.followUps);
    //                             } else if (element.name === 'investigation') {
    //                               return investigationView(
    //                                 element,
    //                                 data?.investigations,
    //                               );
    //                             } else if (element.name === 'rx') {
    //                               return viewRx(element, data?.medicines);
    //                             } else if (element.name === 'on-examination') {
    //                               return onExaminationView(
    //                                 element,
    //                                 data?.onExaminations,
    //                               );
    //                             } else if (element.name === 'special-note') {
    //                               return specialNoteView(
    //                                 element,
    //                                 data?.specialNotes,
    //                               );
    //                             } else if (element.name === 'rehabilitation') {
    //                               return viewRehabilitation(
    //                                 element,
    //                                 data?.rehabilitation,
    //                               );
    //                             } else if (element.name === 'advice') {
    //                               return adviceView(element, data?.advices);
    //                             } else if (element.name === 'eye-glass') {
    //                               return eyeGlassView(element, data?.eyeGlass);
    //                             } else if (element.name === 'infertility') {
    //                               return infertilityView(
    //                                 element,
    //                                 data?.infertilities,
    //                               );
    //                             }
    //                           },
    //                         )}
    //                       </div>
    //                     )}
    //                     {leftOrRightItems(prescriptionItems, 'right').length >
    //                       0 && (
    //                       <div className="prescription-body-right">
    //                         {leftOrRightItems(prescriptionItems, 'right').map(
    //                           (element) => {
    //                             if (element.name === 'chief-complain') {
    //                               return chiefComplainView(
    //                                 element,
    //                                 data?.chiefComplains,
    //                               );
    //                             } else if (element.name === 'treatment-plan') {
    //                               return treatmentPlanView(
    //                                 element,
    //                                 data?.treatmentPlans,
    //                               );
    //                             } else if (element.name === 'referred-to') {
    //                               return referredToView(
    //                                 element,
    //                                 data?.referredto,
    //                               );
    //                             } else if (element.name === 'history') {
    //                               return historyView(element, data?.histories);
    //                             } else if (element.name === 'diagnosis') {
    //                               return viewDiagnosis(
    //                                 element,
    //                                 data?.diagnoses,
    //                                 data?.staging,
    //                               );
    //                             } else if (element.name === 'follow-up') {
    //                               return followUpView(element, data?.followUps);
    //                             } else if (element.name === 'advice') {
    //                               return adviceView(element, data?.advices);
    //                             } else if (element.name === 'rx') {
    //                               return viewRx(element, data?.medicines);
    //                             } else if (element.name === 'on-examination') {
    //                               return onExaminationView(
    //                                 element,
    //                                 data?.onExaminations,
    //                               );
    //                             } else if (element.name === 'special-note') {
    //                               return specialNoteView(
    //                                 element,
    //                                 data?.specialNotes,
    //                               );
    //                             } else if (element.name === 'rehabilitation') {
    //                               return viewRehabilitation(
    //                                 element,
    //                                 data?.rehabilitation,
    //                               );
    //                             } else if (element.name === 'eye-glass') {
    //                               return eyeGlassView(element, data?.eyeGlass);
    //                             } else if (element.name === 'infertility') {
    //                               return infertilityView(
    //                                 element,
    //                                 data?.infertilities,
    //                               );
    //                             }
    //                           },
    //                         )}
    //                       </div>
    //                     )}
    //                   </div>
    //                 </Accordion.Body>
    //               </Accordion.Item>
    //             );
    //           })}
    //         </Accordion>
    //         <TemplateModal
    //           isTemplateModal={isTemplateModal}
    //           setIsTemplateModal={setIsTemplateModal}
    //           templateInput={prescriptionData}
    //         />
    //       </Col>
    //     </Row>
    //   )}
    // </div>

    <div>
      <div className="d-flex flex-row align-items-center justify-content-between mt-3">
        <Button
          variant="primary"
          onClick={
            reversePrescriptions?.length === 0
              ? handleAddNewPrescription
              : followUpPrescription
          }
        >
          Follow up patient prescription
          <i className="far fa-edit ml-1" />
        </Button>
        <Button variant="primary">
          Send patient last prescription <i className="far fa-paper-plane" />
        </Button>
        <Button variant="primary">
          Patients notes <i className="far fa-clipboard" />
        </Button>
      </div>

      <div className="d-flex flex-row align-items-center justify-content-between">
        <div className="mt-4 container-fluid vital-sings-head">Vital signs</div>
      </div>
      <div className="d-flex flex-row align-items-center justify-content-between">
        <div
          className="card shadow d-flex flex-column align-items-center justify-content-between mt-1 p-2"
          style={{ width: '24%' }}
        >
          <img
            src={HeartRate}
            alt="Heart Rate"
            style={{ height: '32px', width: '32px' }}
          />
          {/* <span style={{ height: '100px' }}>
            <HeartRate />
          </span> */}
          <span>Heart Rate</span>
          <span className="black">
            <span className="vital-item-no">
              {lastPrescription?.onExaminations?.generalExaminations?.pulseInfo
                ?.pulse || ''}
            </span>
            {lastPrescription?.onExaminations?.generalExaminations?.pulseInfo
              ?.pulse
              ? ' '
              : 'n/a '}
            <small>bmp</small>
          </span>
        </div>

        <div
          className="card shadow d-flex flex-column align-items-center justify-content-between mt-1 p-2"
          style={{ width: '24%' }}
        >
          {/* <img src="" alt="" /> */}
          <img
            src={OxygenSaturation}
            alt="Oxygen Saturation"
            style={{ height: '32px', width: '32px' }}
          />
          <span>Oxygen Saturation</span>
          <span className="black">
            <span className="vital-item-no">
              {lastPrescription?.onExaminations?.generalExaminations?.spo2 ||
                ''}
            </span>
            {lastPrescription?.onExaminations?.generalExaminations?.spo2
              ? ''
              : 'n/a '}
            <small>%</small>
          </span>
        </div>

        <div
          className="card shadow d-flex flex-column align-items-center justify-content-between mt-1 p-2"
          style={{ width: '24%' }}
        >
          {/* <img src="" alt="" /> */}
          <img
            src={BodyTemparature}
            alt="Body Temparature"
            style={{ height: '32px', width: '32px' }}
          />
          <span>Body Temparature</span>
          <span className="black">
            <span className="vital-item-no">
              {lastPrescription?.onExaminations?.generalExaminations
                ?.temperatureInfo?.temperature ? (
                <>
                  {
                    lastPrescription?.onExaminations?.generalExaminations
                      ?.temperatureInfo?.temperature
                  }
                  <sup>o</sup>
                </>
              ) : (
                ''
              )}{' '}
            </span>
            {lastPrescription?.onExaminations?.generalExaminations
              ?.temperatureInfo?.temperature
              ? ''
              : 'n/a '}
            <small>F</small>
          </span>
        </div>

        <div
          className="card shadow d-flex flex-column align-items-center justify-content-between mt-1 p-2"
          style={{ width: '24%' }}
        >
          {/* <img src="" alt="" /> */}
          <img
            src={BloodPressure}
            alt="Blood Pressure"
            style={{ height: '32px', width: '32px' }}
          />
          <span>Blood Pressure</span>
          <span className="black">
            <span className="vital-item-no">
              {lastPrescription?.onExaminations?.generalExaminations
                ?.bloodPressure?.systolic
                ? `${lastPrescription?.onExaminations?.generalExaminations?.bloodPressure?.systolic}/${lastPrescription?.onExaminations?.generalExaminations?.bloodPressure?.diastolic}`
                : ''}
            </span>
            {lastPrescription?.onExaminations?.generalExaminations
              ?.bloodPressure?.systolic
              ? ''
              : 'n/a '}
            <small>mmHg</small>
          </span>
        </div>
      </div>

      <div
        className="mt-4 container-fluid create-new-prescription-new cursor-pointer"
        onClick={(e) => handleAddNewPrescription(e)}
      >
        + Add Prescription
      </div>
      <div className="card shadow mt-1 p-2 black">
        <h5 className="pl-3 pt-1 bold">Prescriptions</h5>
        <div className="justify-content-space-between-wrap p-2">
          {reversePrescriptions?.map((data, index) => (
            <div
              className="card shadow d-flex flex-column align-items-center justify-content-between my-2 p-2 py-4 prescription-box cursor-pointer"
              onClick={(e) => handleShowPrescription(e, data)}
            >
              <span className="bold font-14 underline">
                {data?.chiefComplains?.[0]?.name}
              </span>
              <span className="small" style={{ marginTop: '-6px' }}>
                {getDuration(data?.createdAt)}
              </span>
              <span className="black">
                {moment(data?.createdAt).format('Do, MMM, YYYY')}
              </span>
            </div>
          ))}

          {/* <div className="card shadow d-flex flex-column align-items-center justify-content-between mt-1 p-2 py-4 prescription-box">
            <span className="bold font-14 underline">Heart Disease</span>
            <span className="small" style={{ marginTop: '-6px' }}>
              3 months
            </span>
            <span className="black">25 Sep, 2025</span>
          </div>{' '}
          <div className="card shadow d-flex flex-column align-items-center justify-content-between mt-1 p-2 py-4 prescription-box">
            <span className="bold font-14 underline">Heart Disease</span>
            <span className="small" style={{ marginTop: '-6px' }}>
              3 months
            </span>
            <span className="black">25 Sep, 2025</span>
          </div>{' '}
          <div className="card shadow d-flex flex-column align-items-center justify-content-between mt-1 p-2 py-4 prescription-box">
            <span className="bold font-14 underline">Heart Disease</span>
            <span className="small" style={{ marginTop: '-6px' }}>
              3 months
            </span>
            <span className="black">25 Sep, 2025</span>
          </div>
          <div className="card shadow d-flex flex-column align-items-center justify-content-between mt-1 p-2 py-4 prescription-box">
            <span className="bold font-14 underline">Heart Disease</span>
            <span className="small" style={{ marginTop: '-6px' }}>
              3 months
            </span>
            <span className="black">25 Sep, 2025</span>
          </div> */}
        </div>
      </div>
      <Modal
        show={prescriptionModal}
        size="lg"
        dialogClassName="modal-lg-wider"
        // style={{ width: '900px !important' }}
      >
        {/* <Modal.Header className="common-modal-header">
          <Col>
            <Modal.Title>Prescription</Modal.Title>
          </Col>
          <Col md={1} style={{ textAlign: 'end' }}>
            <i
              onClick={() => {
                setPrescriptionModal(false);
              }}
              className="far fa-times-circle cursor-pointer"
              aria-hidden="true"
            ></i>
          </Col>
        </Modal.Header> */}
        <Modal.Body className="pb-4">
          <div className="mb-3 prescription-history">
            <div>
              <div className="justify-content-space-between-wrap">
                <div className="ml-3">
                  <span className="accordion-title-text">
                    {prescriptionData?.createdAt
                      ? moment(prescriptionData?.createdAt).format(
                          'D MMMM, YYYY',
                        )
                      : ''}
                  </span>
                </div>
                <div className="right-edit-icon">
                  <span
                    className="prescription-modal-template"
                    onClick={(e) => createTemplateModal(prescriptionData, e)}
                  >
                    <i className="far fa-file"></i> Templates
                  </span>

                  {/* <Link
                    to={'/prescription'}
                    className="prescription-modal-template"
                    state={{
                      prescription: prescriptionData,
                      dob: prescriptionData?.patientId?.dob,
                      note: note,
                      history: 'editFromHistory',
                    }}
                  >
                    <i className="fa fa-edit"></i> Follow Up
                  </Link> */}

                  <span
                    className="prescription-modal-followup"
                    onClick={(e) => handleFollowUp(prescriptionData, e)}
                  >
                    <i className="far fa-edit"></i> Follow Up
                  </span>

                  <span
                    className="pres-del"
                    style={{
                      width: '4.3rem',
                      display: 'inline-block',
                      color: '#b3466a',
                      cursor: 'pointer',
                    }}
                    onClick={(e) => {
                      deleteConfirmation(
                        deletePrescription,
                        prescriptionData.id,
                      );
                      e.stopPropagation();
                    }}
                  >
                    <i className="far fa-trash-alt"></i> Delete
                  </span>

                  <i
                    className="far fa-times-circle cursor-pointer pl-3"
                    onClick={(e) => setPrescriptionModal(false)}
                  />
                </div>
              </div>
              <div
                className="justify-content-centered mr-1 mt-4 pt-3 pb-2"
                style={{ borderTop: '1px solid #e9e9e9' }}
              >
                <span className="indivisual-prescription-stat">
                  Chief Complain:{' '}
                  {prescriptionData?.chiefComplains?.length
                    ? prescriptionData?.chiefComplains?.length
                    : 0}
                </span>
                <span className="indivisual-prescription-stat">
                  Diagnosis:{' '}
                  {prescriptionData.diagnoses?.length
                    ? prescriptionData.diagnoses?.length
                    : 0}
                </span>
                <span className="indivisual-prescription-stat">
                  Rx:{' '}
                  {prescriptionData?.medicines?.length
                    ? prescriptionData?.medicines?.length
                    : 0}
                </span>
                <span className="indivisual-prescription-stat">
                  Investigation:{' '}
                  {prescriptionData?.investigations?.length
                    ? prescriptionData.investigations?.length
                    : 0}
                </span>
                <span className="indivisual-prescription-stat">
                  Advice:{' '}
                  {prescriptionData.advices?.length
                    ? prescriptionData.advices?.length
                    : 0}
                </span>
                <span className="indivisual-prescription-stat">
                  Follow up:{' '}
                  {prescriptionData.followUps?.length
                    ? prescriptionData.followUps?.length
                    : 0}
                </span>
              </div>
            </div>
            <div>
              <div className="row prescription-body pt-2">
                {leftOrRightItems(prescriptionItems, 'left').length > 0 && (
                  <div className="prescription-body-left pl-4">
                    {leftOrRightItems(prescriptionItems, 'left').map(
                      (element) => {
                        if (element.name === 'chief-complain') {
                          return chiefComplainView(
                            element,
                            prescriptionData?.chiefComplains,
                          );
                        } else if (element.name === 'treatment-plan') {
                          return treatmentPlanView(
                            element,
                            prescriptionData?.treatmentPlans,
                          );
                        } else if (element.name === 'referred-to') {
                          return referredToView(
                            element,
                            prescriptionData?.referredto,
                          );
                        } else if (element.name === 'history') {
                          return historyView(
                            element,
                            prescriptionData?.histories,
                          );
                        } else if (element.name === 'diagnosis') {
                          return viewDiagnosis(
                            element,
                            prescriptionData?.diagnoses,
                            prescriptionData?.staging,
                          );
                        } else if (element.name === 'follow-up') {
                          return followUpView(
                            element,
                            prescriptionData?.followUps,
                          );
                        } else if (element.name === 'investigation') {
                          return investigationView(
                            element,
                            prescriptionData?.investigations,
                          );
                        } else if (element.name === 'rx') {
                          return viewRx(element, prescriptionData);
                        } else if (element.name === 'on-examination') {
                          return onExaminationView(
                            element,
                            prescriptionData?.onExaminations,
                          );
                        } else if (element.name === 'special-note') {
                          return specialNoteView(
                            element,
                            prescriptionData?.specialNotes,
                          );
                        } else if (element.name === 'rehabilitation') {
                          return viewRehabilitation(
                            element,
                            prescriptionData?.rehabilitation,
                          );
                        } else if (element.name === 'advice') {
                          return adviceView(element, prescriptionData?.advices);
                        } else if (element.name === 'eye-glass') {
                          return eyeGlassView(
                            element,
                            prescriptionData?.eyeGlass,
                          );
                        } else if (element.name === 'infertility') {
                          return infertilityView(
                            element,
                            prescriptionData?.infertilities,
                          );
                        } else {
                          return dynamicItemView(
                            element,
                            prescriptionData?.dynamicItems,
                          );
                        }
                      },
                    )}
                  </div>
                )}
                {leftOrRightItems(prescriptionItems, 'right').length > 0 && (
                  <div className="prescription-body-right pl-5">
                    {leftOrRightItems(prescriptionItems, 'right').map(
                      (element) => {
                        if (element.name === 'chief-complain') {
                          return chiefComplainView(
                            element,
                            prescriptionData?.chiefComplains,
                          );
                        } else if (element.name === 'treatment-plan') {
                          return treatmentPlanView(
                            element,
                            prescriptionData?.treatmentPlans,
                          );
                        } else if (element.name === 'referred-to') {
                          return referredToView(
                            element,
                            prescriptionData?.referredto,
                          );
                        } else if (element.name === 'history') {
                          return historyView(
                            element,
                            prescriptionData?.histories,
                            true,
                          );
                        } else if (element.name === 'diagnosis') {
                          return viewDiagnosis(
                            element,
                            prescriptionData?.diagnoses,
                            prescriptionData?.staging,
                          );
                        } else if (element.name === 'follow-up') {
                          return followUpView(
                            element,
                            prescriptionData?.followUps,
                          );
                        } else if (element.name === 'advice') {
                          return adviceView(element, prescriptionData?.advices);
                        } else if (element.name === 'rx') {
                          return viewRx(element, prescriptionData);
                        } else if (element.name === 'on-examination') {
                          return onExaminationView(
                            element,
                            prescriptionData?.onExaminations,
                          );
                        } else if (element.name === 'special-note') {
                          return specialNoteView(
                            element,
                            prescriptionData?.specialNotes,
                          );
                        } else if (element.name === 'rehabilitation') {
                          return viewRehabilitation(
                            element,
                            prescriptionData?.rehabilitation,
                          );
                        } else if (element.name === 'eye-glass') {
                          return eyeGlassView(
                            element,
                            prescriptionData?.eyeGlass,
                          );
                        } else if (element.name === 'infertility') {
                          return infertilityView(
                            element,
                            prescriptionData?.infertilities,
                          );
                        } else {
                          return dynamicItemView(
                            element,
                            prescriptionData?.dynamicItems,
                          );
                        }
                      },
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <TemplateModal
        isTemplateModal={isTemplateModal}
        setIsTemplateModal={setIsTemplateModal}
        templateInput={prescriptionData}
      />
    </div>
  );
};

export default memo(PatientHistoryRight);
